<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/80CVVe/tc-custom/9781625857897.jpg?1702529293403" alt="This image is the cover for the book The Beach Ball Classic: Premier High School Hoops on the Grand Strand, Sports"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Beach Ball Classic: Premier High School Hoops on the Grand Strand, Sports
      </h1>
      <p class="bookDescription body article font2">
        <p>The Beach Ball Classic began in 1981 as a modest avenue for coach Dan D'Antoni to attract the attention of college scouts. It blossomed into one of the premier prep basketball tournaments in the nation. From Kobe Bryant and Vince Carter to Roy Williams, some of the game's biggest stars and most colorful coaches have taken part. They also brought attention to an area generally overlooked in terms of high school sports. With calculated moves, a few risky decisions and nationwide sporting trends, the tournament continued to expand its influence. Author Ian Guerin recounts the famous faces, upcoming stars and business acumen that have made the Classic an iconic event for thirty-five years.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ian Guerin, John Rhodes
      </h2>
      
      <p class="authorDescription body article">Ian Guerin is a freelance writer living in Myrtle Beach, South Carolina. Over the course of nearly two decades, the University of Missouri graduate has covered a variety of teams and sports on the high school and college levels, most notably in the Palmetto State. He and his wife, Katie, have two children, Sawyer and Austen.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5b82b460